import {Collection} from '@blesk-frontend/api';
import {getStepWithImage} from '@blesk-frontend/ui';
import {Link} from '@tanstack/react-router';
import {useMemo} from 'react';
import {CollectionImageStack} from './CollectionImageStack';

interface CollectionCardProps {
  collection: Collection;
}

export const CollectionCard = ({collection}: CollectionCardProps) => {
  const imgStep = useMemo(
    () => getStepWithImage(collection.guides.at(0)?.guide.steps || []),
    [collection.guides],
  );

  return (
    <Link
      className="group relative flex flex-col text-text-primary"
      to="/collections/$collectionId"
      params={{collectionId: collection.id}}
    >
      <div key={`collection-card-${collection.id}`}>
        <CollectionImageStack count={collection._count.guides} imgStep={imgStep} />
        <div className="mt-2 line-clamp-2 shrink-0 px-2 text-paragraph-sm">{collection.name}</div>
        <div className="mt-1 shrink-0 px-2 text-paragraph-xs text-text-muted">
          {collection.user.fullName}
        </div>
      </div>
    </Link>
  );
};
